import { useEffect } from "react";
import { MenuType } from "../../redux/userManagement/userManagementTypes";
import Checkbox from '../commons/Checkbox';

type AppProps = {
  menuDetails: MenuType;
  selectedMenus: any[];
  handleSelectMenu: (menuId: number) => void;
  indentation: number;
}

const NestedListItem = ({
  menuDetails,
  handleSelectMenu,
  selectedMenus,
  indentation
}: AppProps) => {

  return (
    <>
      <div className="col-md-4">
        <div className="d-flex pt-2" style={{ paddingLeft: `${ indentation * 18 }px` }}>
          <Checkbox onPress={() => handleSelectMenu(menuDetails?.menu_id)}
            checked={selectedMenus?.includes(menuDetails?.menu_id)}
          // disabled={!!menuDetails?.coming_soon}
          />
          <p className="pl-2">{menuDetails?.menu_name}</p>
        </div>
      </div>
      {
        menuDetails?.sub_menu && menuDetails?.sub_menu?.length > 0 && menuDetails?.sub_menu?.map((menuData: MenuType) => {
          return (
            <NestedListItem
              menuDetails={menuData}
              handleSelectMenu={handleSelectMenu}
              selectedMenus={selectedMenus}
              indentation={indentation + 1}
            />
          )
        })
      }
    </>
  )
};

export default NestedListItem;